 window.addEventListener("load",function(){
      
      })
const checkboxes = document.querySelectorAll('input[type="checkbox"][name="recommended_product_id"]');
checkboxes.forEach((checkbox) => {
  checkbox.addEventListener('change', (event) => {
    if (event.target.checked) {
      checkboxes.forEach((cb) => {
        if (cb !== event.target) {
          cb.checked = false;
        }
      });
    }
  });
});